import React from 'react';
import { Search, Zap, LineChart } from 'lucide-react';
import { CAPABILIA_GREEN } from './landingConstants';

const STEPS = [
  { icon: Search, num: '01', title: 'Detectar', desc: 'Cruzamos avance académico, actividad y señales comerciales para calcular el semáforo de riesgo de cada alumno.' },
  { icon: Zap, num: '02', title: 'Accionar', desc: 'Cada color dispara un plan de retención con objetivo, canal y mensaje ya definidos - sin improvisar.' },
  { icon: LineChart, num: '03', title: 'Medir', desc: 'Comparamos contra un grupo de control para saber si la acción realmente cambió el resultado.', badge: 'En piloto' },
];

export const LandingHowItWorks = () => (
  <section id="como-funciona" className="max-w-7xl mx-auto px-6 py-20" data-testid="landing-how-it-works">
    <div className="text-center max-w-2xl mx-auto mb-14">
      <p className="text-sm font-semibold text-emerald-700 mb-3">Cómo funciona</p>
      <h2 className="font-manrope text-3xl sm:text-4xl font-bold text-gray-900">
        Un ciclo simple, corrido todas las semanas
      </h2>
    </div>

    <div className="grid md:grid-cols-3 gap-6">
      {STEPS.map((step) => (
        <div key={step.num} className="relative bg-white border border-gray-100 rounded-2xl p-6 shadow-sm" data-testid={`landing-step-${step.num}`}>
          {step.badge && (
            <span
              className="absolute -top-3 right-5 text-[11px] font-semibold px-3 py-1 rounded-full text-white"
              style={{ backgroundColor: CAPABILIA_GREEN }}
            >
              {step.badge}
            </span>
          )}
          <span className="font-mono text-xs text-gray-400">{step.num}</span>
          <div className="w-11 h-11 rounded-xl flex items-center justify-center my-4" style={{ backgroundColor: `${CAPABILIA_GREEN}1A` }}>
            <step.icon className="w-5 h-5" style={{ color: CAPABILIA_GREEN }} />
          </div>
          <h3 className="font-manrope font-bold text-lg text-gray-900 mb-2">{step.title}</h3>
          <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
        </div>
      ))}
    </div>
  </section>
);
